import sectors from '../config/sectors';
import regions from '../config/regions';

export default {
	namespaced: true,
	state: {
		list: [],
		template: {}
	},
	actions: {
		async getList({ commit }) {
			// no need for this function leave it to avoid spend time
		},
		async setTemplate({ commit, state }, query) {
			const sector = sectors.sectors.find(sector => sector.id === query.sectorId);
			const region = regions.regions.find(region => region.id === query.regionId);

			commit('set', {
				type: 'list', value: [...state.list, {
					...query,
					sector,
					region,
					id: Math.random()
				}]
			})

		},
		async getTemplate({ commit, state }) {
			let templateId = this.state.route.params.templateId

			const filteredTemplates = state.list
				.filter(template => {
					return templateId = template.id;
				})
			console.log(filteredTemplates[0])
			commit('set', { type: 'template', value: filteredTemplates[0] })
		},

	},
	mutations: {
		set(state, { type, value }) {
			state[type] = value
		}
	}
}
